import { useMemo } from 'react';
import { encode } from 'uqr';

/**
 * A QR code as inline SVG, drawn in the ink colour on the surface (style guide:
 * tokens only). Built locally from the key URI; the secret never leaves the page.
 */
export function QrCode({ value, label }: { readonly value: string; readonly label: string }) {
  const { size, path } = useMemo(() => {
    const code = encode(value, { ecc: 'M', border: 2 });
    let d = '';
    code.data.forEach((row, y) =>
      row.forEach((on, x) => {
        if (on) d += `M${x} ${y}h1v1h-1z`;
      }),
    );
    return { size: code.size, path: d };
  }, [value]);
  return (
    <svg className="ui-console-qr" viewBox={`0 0 ${size} ${size}`} role="img" aria-label={label} shapeRendering="crispEdges">
      <rect className="ui-console-qr__bg" width={size} height={size} />
      <path className="ui-console-qr__fg" d={path} />
    </svg>
  );
}
